import React from "react";
import { useTranslation } from "react-i18next";

export const LocationCoverage: React.FC<{ data: any }> = ({ data }) => {
    const { t } = useTranslation("task_manager");

    if (!data || Object.keys(data).length === 0) {
        return (
            <p className="text-sm text-slate-500 py-4">
                {t("location_data_not_found") || "Location data not found"}
            </p>
        );
    }

    return (
        <div className="space-y-2">
            {Object.keys(data).map((location) => (
                <div
                    key={location}
                    className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border border-slate-200"
                >
                    <div className="flex items-center gap-3">
                        {data[location]["complete"] ? (
                            <i className="fas fa-circle-check text-lg text-emerald-500" />
                        ) : (
                            <i className="fas fa-circle-exclamation text-lg text-amber-500" />
                        )}
                        <div>
                            <p className="text-sm font-medium text-slate-900">
                                {t("location") || "Location"}: {location}
                            </p>
                        </div>
                    </div>
                    {data[location]["ref"] && (
                        <a
                            href={`http://maps.google.com/maps?saddr=12.9737549,77.5735036&daddr=${data[location]["ref"]["lat"]},${data[location]["ref"]["lng"]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm text-indigo-600 hover:text-indigo-700 font-medium flex items-center gap-1"
                        >
                            <i className="fas fa-directions text-xs" />
                            {t("get_directions") || "Directions"}
                        </a>
                    )}
                </div>
            ))}
        </div>
    );
};
